<template>
    <div class="banner">
        <swiper :options="swiperOptiona" ref="mySwipers" class="swiper">
            <swiper-slide class="item" v-for="(item,index) in bList" :key="index">
                <img :src="`http://www.zrichhome.com/${item.picurl}`" alt="">
                <div class="text">
                    <div class="cn">
                        {{item.description}}
                    </div>
                    <div class="btn" @click="gotoAbout">
                        discover
                    </div>
                </div>
            </swiper-slide>
        </swiper>
        <swiper :options="swiperOptiona2" ref="mySwipers2" class="swiper2">
            <swiper-slide class="item" v-for="(item,index) in bList" :key="index">
                <img :src="`http://www.zrichhome.com/${item.pimg}`" alt="">
                <div class="text">
                    <div class="cn">
                        {{item.description}}
                    </div>
                    <div class="btn" @click="gotoAbout">
                        discover
                    </div>
                </div>
            </swiper-slide>
        </swiper>
        <div class="swiper-pagination">

        </div>
    </div>
</template>

<script>
    import {swiper, swiperSlide} from "vue-awesome-swiper";
    import "swiper/dist/css/swiper.css";
    import {getProductsUrl} from '../util/lang'
    import '../common/jquery-1.11.3.min'

    export default {
        name: "banner",
        data() {
            let _this = this
            return {
                bList: [],
                swiperOptiona: {
                    pagination: {
                        el: ".banner .swiper-pagination",
                        clickable: true,
                        renderBullet: function (index, className) {
                            return '<span class="' + className + '"><i></i></span>';
                        }
                    },
                    loop: true,
                    effect: 'fade',
                    init: false,
                    autoplay: {
                        disableOnInteraction: false,
                        delay: 2000
                    },
                    on: {
                        slideChangeTransitionEnd: () => {
                            this.$nextTick(() => {
                                let swiper = _this.$refs.mySwipers.swiper;
                                let active = swiper.realIndex;
                                let previousIndex = swiper.previousIndex;
                                let bullets = swiper.pagination.bullets;
                                let bulletsArray = Array.from(bullets);
                                for (let i = 0; i < bulletsArray.length; i++) {
                                    $('.banner .swiper-pagination .swiper-pagination-bullet').eq(i).children('i').stop().width("0%")
                                }
                                for (let i = 0; i < active; i++) {
                                    $('.banner .swiper-pagination .swiper-pagination-bullet').eq(i).children('i').stop().width("100%")
                                }
                                $('.banner .swiper-pagination .swiper-pagination-bullet').eq(active).children('i').stop().animate({width: '100%'}, 5000, "linear")


                            });
                        }
                    },
                },
                swiperOptiona2: {
                    // el: ".banner .swiper-pagination2",
                    pagination: {
                        clickable: true,
                    },
                    effect:'fade',
                    loop: true,
                    init: false,
                    autoplay: {
                        disableOnInteraction: false,
                        delay: 2000
                    },
                },
            }
        },
        components: {
            swiper,
            swiperSlide,
        },
        mounted() {
            setTimeout(() => {
                this.getList('1')
            }, 100)
        },
        methods: {
            gotoAbout() {
                window.open('/pro.html', '_blank')
            },
            getList(id) {
                const url = `${getProductsUrl(id)}`
                this.$axios.get(url).then(res => {
                    this.bList = res.data.data
                    // console.log(this.bList)
                    setTimeout(() => {
                        this.$refs.mySwipers.swiper.init()
                        this.$refs.mySwipers2.swiper.init()
                    }, 100)
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .banner {
        width: 100%;
        position: relative;

        .swiper {
            height: 100%;

            .item {
                position: relative;
                overflow: hidden;

                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    display: block;
                    z-index: 1;
                    cursor: pointer;
                    transform: scale(1);
                    transition: all 2s;
                }

                .text {
                    z-index: 10;
                    position: absolute;
                    left: 10%;
                    top: 45%;
                    width: 80%;
                    color: transparent;

                    .cn {
                        text-align: center;
                        font-size: 26px;
                        font-family: "SourceHanSerifCN-Medium";
                        color: white;
                        transform: translate3d(-50%, 0, 0) skewX(-60deg);
                        opacity: 0;
                        transition: all 2s;
                    }

                    .btn {
                        width: 160px;
                        height: 50px;
                        border: 1px solid rgba(255, 255, 255, 1);
                        color: #FFFFFF;
                        text-align: center;
                        font-family: "SourceHanSerifCN-Medium";
                        margin: 0 auto;
                        line-height: 50px;
                        cursor: pointer;
                        font-size: 14px;
                        text-transform: uppercase;
                        transform: translate3d(50%, 0, 0) skewX(-60deg);
                        opacity: 0;
                        transition: all 1s;
                        z-index: 100000;
                        margin-top: 60px;
                        transition-delay: 1s;

                        &:hover {
                            background: rgba(51, 49, 55, 1);
                            color: white;
                        }
                    }
                }
            }

            .swiper-slide-active {
                img {
                    transform: scale(1.05);
                }

                .text {
                    .cn {
                        transform: translate3d(0, 0, 0) skew(0);
                        opacity: 1;
                    }

                    .btn {
                        transform: translate3d(0, 0, 0) skew(0);
                        opacity: 1;
                    }
                }
            }
        }

        .swiper2{
            display: none;
            width: 100%;
            .item {
                position: relative;
                overflow: hidden;
                height: 500px;
                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    display: block;
                    z-index: 1;
                    cursor: pointer;
                    transform: scale(1);
                    transition: all 2s;
                }

                .text {
                    z-index: 10;
                    position: absolute;
                    left: 10%;
                    top: 45%;
                    width: 80%;
                    color: transparent;
                    .cn {
                        text-align: center;
                        font-size: 25px;
                        font-family: "SourceHanSerifCN-Medium";
                        color: white;
                        transform: translate3d(-50%, 0, 0) skewX(-60deg);
                        opacity: 0;
                        transition: all 2s;
                    }

                    .btn {
                        width: 100px;
                        border: 1px solid rgba(255, 255, 255, 1);
                        color: #FFFFFF;
                        text-align: center;
                        font-family: "SourceHanSerifCN-Medium";
                        margin: 0 auto;
                        line-height: 35px;
                        cursor: pointer;
                        font-size: 14px;
                        text-transform: uppercase;
                        transform: translate3d(50%, 0, 0) skewX(-60deg);
                        opacity: 0;
                        transition: all 1s;
                        z-index: 100000;
                        margin-top: 60px;
                        transition-delay: 1s;

                        &:hover {
                            background: rgba(51, 49, 55, 1);
                            color: white;
                        }
                    }
                }
            }
            .swiper-slide-active {
                img {
                    transform: scale(1.05);
                }

                .text {
                    .cn {
                        transform: translate3d(0, 0, 0) skew(0);
                        opacity: 1;
                    }

                    .btn {
                        transform: translate3d(0, 0, 0) skew(0);
                        opacity: 1;
                    }
                }
            }
        }
        .button-prev, .button-next {
            transition: 0.5s;
            outline: none;
            position: absolute;
            width: 140px;
            z-index: 10;
            top: 50vh;
            transform: translateY(-34px);
            cursor: pointer;

            svg {
                transition: 0.5s;
            }
        }

        .button-prev {
            left: 4vw;

            #arrow-svg-home {
                transform: translateY(353px);
            }
        }

        .button-next {
            right: 4vw;
        }

        .button-next #arrow-svg-home {
            transform: translateY(353px) rotateY(180deg);
            transform-origin: 80px 0px 0px;
        }

        .cls-1 {
            transition: 0.5s;
            transform-origin: -20px 40px;
            opacity: 1;
        }

        .cls-4 {
            transition: 0.5s;
            stroke-width: 2px;
            stroke: #fff;
            fill: none;
            stroke-dasharray: 1;
            stroke-dashoffset: 1;
            opacity: 0.4;
            transform-origin: 0px 0px 0px;
        }

        #arrow-trg {
            transition: 0.5s;
            fill: #fff;
            transform: rotateY(180deg) translate(-53px, 39px);
        }

        #line {
            transition: 0.5s;
            stroke: #fff;
            transform: translate(50px, 42px);
        }

        .button:hover {
            svg {
                transform: translateX(25px);
            }

            .cls-1 {
                transform: scale(1.1);
            }

            .cls-4 {
                stroke-dasharray: 2px;
                stroke-dashoffset: 2px;
                opacity: 1;
            }

            #arrow-trg {
                transform: rotateY(180deg) translate(-37px, 39px);
            }

            #line {
                transform: translate(35px, 42px) scaleX(0.33);
            }
        }

        @media screen and (max-width: 1440px) and (min-width: 1000px) {
            .swiper {
            }
        }
        @media screen and (max-width: 1000px) {
            .swiper {
                display: none;
                .item {
                    img {
                        height: 600px;
                    }
                }
            }
            .swiper2{
                display: block;
                .item{
                    .text{
                        .cn{
                            font-size: 20px;
                        }
                    }
                }
            }
        }
    }
</style>
<style scoped>
    .banner .swiper-pagination {
        bottom: 10%;
        width: 100%;
        left: 0;
        display: flex;
        flex-direction: row;
        justify-content: center;
    }

    .banner .swiper-pagination >>> .swiper-pagination-bullet{
        width: 5px;
        height: 5px;
        background: rgba(255, 255, 255, 1);
        border-radius: 50%;
        margin-left: 30px;
    }

    .banner .swiper-pagination >>> .swiper-pagination-bullet:focus {
        outline: none;
    }
</style>
